import { MapTo } from '@adobe/aem-react-editable-components';
import CreditProtection, { CreditProtectionEditConfig } from './CreditProtection';

export default MapTo('cob-corp-acquisition/components/creditonebank/credit-protection')(CreditProtection, CreditProtectionEditConfig);